<template>
    <div class="expediting-container">
        <div class="doc">可设置用户投稿后多久未审核时，可发起“催审”</div>
        <div class="input-box">
            <span class="title">可催审时间</span>
            <!-- <input type="text" placeholder="可设置用户投稿后多久未审核时，可发起“崔审”"> -->
            <el-input v-model="check_days" placeholder="可设置用户投稿后多久未审核时，可发起“崔审”"></el-input>
        </div>
        <div class="input-box">
            <span class="title">可催稿上线时间</span>
            <!-- <input type="text" placeholder="可设置用户稿件通过后多久未上线时，可发起“崔稿上线”"> -->
            <el-input v-model="online_days" placeholder="可设置用户稿件通过后多久未上线时，可发起“崔稿上线"></el-input>
        </div>
        <div class="btn_box">
            <el-button type="primary" @click="preservation" :loading="loading" v-access:edit>保存 </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                check_days:'',
                online_days:'',
                loading:false
            }
        },
        mounted(){
            this.init()
        },
        methods:{
            init(){
                let _this = this
                _this.$store.dispatch('expediting_vuex/operate_boostCheckDetail', {
                    data:{
                        access_token:localStorage.getItem("access_token"),
                    },
                    scCallback(res) {
                        console.log(res,'res')
                        _this.check_days = res.check_days
                        _this.online_days = res.online_days
                    },
                    afterCallback(err) {
                    }
                })
            },
            preservation(){
                if(!this.check_days){
                    this.$message.error('请输入催稿时间');
                    return
                }
                if(!this.online_days){
                    this.$message.error('请输入崔稿上线时间');
                    return
                }

                let _this = this
                 _this.loading = true
                _this.$store.dispatch('expediting_vuex/operate_boostCheckConfig', {
                    data:{
                        access_token:localStorage.getItem("access_token"),
                        check_days:this.check_days,//催审天数
                        online_days:this.online_days,//催上线天数
                    },
                    scCallback(res) {
                        _this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        _this.loading = false
                    },
                    afterCallback(err) {
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
.expediting-container{
    padding: 15px;
    .doc{
        margin-bottom: 50px;
    }
    .input-box{
        display: flex;
        align-items: center;
        margin: 10px 0;
        .title{
            display: flex;
            justify-content: flex-end;
            width: 150px;
            padding: 0 10px;
        }
        .el-input{
            width: 400px;
        }
    }
    .btn_box{
        display: flex;
        justify-content: center;
        padding: 50px 0;
    }
}
</style>